<template>
    <div>
          <ul class="record-list2">
            <li v-for="(record, index) in records" :key="index">
              <div class="record-info">
                <div class="paper-title">{{ record.paper.title }}</div>
                <div class="record-meta">
                  <span >{{ record.end_at }}</span>
                  <span v-if="record.status === 1" class="text-red"
                    >未完成</span
                  >
                  <span v-if="record.status === 2" style="margin-left: 10px;"
                    >共{{ record.count }}道题，做对{{ record.right }}道</span
                  >
                </div>
              </div>
              <div class="action-btns">
                <button
                  v-if="record.status === 1"
                  class="btn btn-green"
                  @click="continueExam(record)"
                >
                  继续做题
                </button>
                <button
                  v-if="record.status === 2"
                  class="btn btn-blue"
                  @click="handlReport(record.id)"
                >
                  查看报告
                </button>
                <button
                  v-if="record.status === 2"
                  class="btn btn-green"
                  @click="handlAgain(record.paper_id)"
                >
                  再次练习
                </button>
              </div>
            </li>
          </ul>
        </div>
</template>

<script>


export default {
  props: {
    records: {
      type: Array,
    },
  },
  methods:{
 
    continueExam(e) {
      this.$router.push(
        "/questionBank/examDetails?id=" + e.paper_id + "&exam_id=" + e.id
      );
    },
    handlReport(id) {
      this.$router.push(`/questionBank/reportScore/${id}`);
    },
    handlAgain(paper_id) {
      this.$router.push("/questionBank/examDetails?id=" + paper_id);
    },
  }
};
</script>

<style lang="less" scoped>

.record-list ul {
  list-style: none;
  padding: 0 20px;
}

.record-list li {
  padding: 15px 0;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.record-info {
  flex: 1;
  margin-right: 20px;
}

.paper-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 5px;
}

.record-meta {
  font-size: 14px;
  color: #666;
}

.text-red {
  color: #f44336;
  margin-left: 10px;
}

.action-btns {
  display: flex;
  align-items: center;
}

.btn {
  // padding: 6px 12px;
  border: none;
  // border-radius: 4px;
  cursor: pointer;

  background: #fff5eb;
  font-size: 14px;
  color: #ff8700;
  letter-spacing: 0;
  text-align: center;
  line-height: 16px;

  border-radius: 16px;
  height: 32px;
  padding: 0 20px;
}

.btn-green {
  background: linear-gradient(
    90deg,
    #51dbb1 0%,
    #45dca9 35%,
    #23dd91 74%,
    #17de89 100%
  );
  color: white;
}
.btn-green:hover {
  color: #107a4d;
}

.btn-blue {
  background: linear-gradient(
    90deg,
    #83c9fd 0%,
    #7ec3fc 35%,
    #73b5fb 74%,
    #70affb 100%
  );
  color: white;
  margin-right: 10px;
}
.btn-blue:hover {
  color: #1e80ff;
}
</style>